// extracted by mini-css-extract-plugin
export default {"footer":"InterceptNavigationMessageModal_footer__twDWS","saveButton":"InterceptNavigationMessageModal_saveButton__xGf13"};